// Helpers de validación para la cédula ecuatoriana (10 dígitos numéricos).
// No valida el dígito verificador (módulo 10) — solo formato: solo números, longitud exacta.

/** Deja solo dígitos y limita a 10 caracteres. Usar en el onChange del input mientras se escribe. */
export const soloDigitosCedula = (value) => String(value || '').replace(/\D/g, '').slice(0, 10);

/** true si el valor son exactamente 10 dígitos numéricos. Usar antes de guardar. */
export const esCedulaCompleta = (value) => /^\d{10}$/.test(String(value || '').trim());

/** Mensaje de alerta según el problema: vacío, letras coladas, o dígitos de más/de menos. */
export const mensajeErrorCedula = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return 'Ingresa la cédula.';
  if (/\D/.test(raw)) return 'La cédula solo debe contener números.';
  if (raw.length !== 10) return `La cédula debe tener exactamente 10 dígitos (tiene ${raw.length}).`;
  return 'La cédula debe tener exactamente 10 dígitos numéricos.';
};
